'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Returns absolute type of an unknown entitiy.
 * We like to call a spade a spade and not "object" :)
 *
 * @param {*} unknown
 * @return {string}
 */
var _typeof = function _typeof(unknown) {
  if (typeof unknown === 'undefined') {
    return 'undefined';
  }

  return Object.prototype.toString.call(unknown).slice(8, -1).toLowerCase();
};

exports.default = _typeof;
